export default {
  setAllDiscountRates(state, discountRates) {
    state.discountRates = discountRates;
  },
  addDiscountRate(state, discountRate) {
    state.discountRates.push(discountRate);
  },
  editDiscountRate(state, discountRate) {
    const index = state.discountRates.findIndex(element => element.idInDb === discountRate.idInDb);
    if (index !== -1) {
      state.discountRates.splice(index, 1, discountRate);
    }
  },
};
